import { useMsal } from '@azure/msal-react';
import React from 'react';
import LogoGlugroft from '../assets/logo-glucroft.svg';
import { loginRequest } from '../authConfig';
import IcoMail from '../assets/ico-mail';
import { selectActiveFeatures } from '../reducers/auth-slice';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import IcoQuestion from '../assets/ico-question';
import { resetState } from '../reducers/active-form-slice';
import { resetAdditionalInformationFiles } from '../reducers/additional-information-files-slice';
import { resetSWITRSDetailsFiles } from '../reducers/switrs-details-files-slice';
import { resetTrafficCollisionsReportRetrievalFiles } from '../reducers/traffic-collisions-report-retrieval-files-slice';
import { resetFaultInfoFilesStatus } from '../reducers/fault-info-files-slice';
import { resetAttachmentsAfterSubmission } from "../reducers/attachments-slice";
import ConfirmCancelModal from "../components/modals/confirm-cancel-order";

const Header = (props) => {

    const { showUserName } = props;
    const { instance, inProgress } = useMsal();
    const activeFeatures = useSelector(selectActiveFeatures);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    let activeAccount;
    if (instance) {
        activeAccount = instance.getActiveAccount();
    }
    const handleLoginRedirect = (e) => {
        e.preventDefault();
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    }

    const handleClick = (e) => {
        e.preventDefault();
        
    };

    const [showConfirmCancelModal, setShowConfirmCancelModal] = useState(false);
    const toggleConfirmCancelModal = () => {
        setShowConfirmCancelModal(!showConfirmCancelModal);
    }

    const handleResetFormValues = async () => {
        await dispatch(resetState());
        await dispatch(resetSWITRSDetailsFiles());
        await dispatch(resetAdditionalInformationFiles());
        await dispatch(resetTrafficCollisionsReportRetrievalFiles());
        await dispatch(resetFaultInfoFilesStatus());
        await dispatch(resetAttachmentsAfterSubmission());
    }; 


    /**
     * handle the next button
     */
    const handleNext = async () => {
        await handleResetFormValues();
        navigate("/portal");
    };

    return (
        <div className='header'>
            <div className='header-logo'>
                A product by
                {location.pathname.includes("/intake") ? <a href="#" onClick={toggleConfirmCancelModal}><img src={LogoGlugroft} alt='glucroft investigations' /></a> :
                    <a href="/"><img src={LogoGlugroft} alt='glucroft investigations' /></a> }
            </div>
            {
                showUserName && activeAccount ?
                    <div className='header-username'>
                        <div className='notification'>
                            {(activeFeatures.includes('f_FieldInvestigator_AssignRoles') || activeFeatures.includes('f_InternalInvestigator_AssignRoles')) ? <></> : <a className='button notification' href="/orders/notifications"><IcoMail /> &nbsp; &nbsp; New Notifications</a>}
                        </div>
                        <div className='notification'>
                            <a href="/help"><IcoQuestion /></a>
                        </div>
                        {activeAccount.name}
                    </div>
                :
                <a className='header-username' onClick={handleLoginRedirect}><div className='notification'><a href="/help"><IcoQuestion /></a></div>Login</a>
            }

            {location.pathname.includes("/intake") && <ConfirmCancelModal
                showConfirmCancelModal={showConfirmCancelModal}
                handleHideConfirmCancelModal={toggleConfirmCancelModal}
                handleShowSubmissionFailureModal={handleNext}
                handleResetFormValues={handleNext}
            />}
        </div>
    );
}

export default Header;